import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginBackButton from "../../../components/SignUpLoginForgot/LoginBackButton";
import PowerGoAndSubheader from "../../../components/SignUpLoginForgot/PowerGoAndSubheader";
import ImgHeaderSubheader from "../../../components/SignUpLoginForgot/ImgHeaderSubheader";
import {
  LoginLayout,
  WidthWrapper,
  LoginInnerWrapperOther,
  OTPFieldsWrapper,
} from "../../../components/SignUpLoginForgot/LoginStyledComponents";
import Button from "../../../components/Button";
import OTPfield from "../../../components/OTPfield";
import { Colors, Text } from "../../../config";
import ErrorModal from "../../../components/ErrorSuccessModal/ErrorModal";
import { resetPin } from "../../../services/userServices";
import { useLoaderContext } from "../../../contexts/loaderContext";
const nextIcon = require("../../../assets/images/Arrow_Right.png");

const ForgotReset = () => {
  const navigate = useNavigate();
  const [newPin, setNewPin] = useState("");
  const [reEnterPin, setReEnterPin] = useState("");
  const [showNewPin, setShowNewPin] = useState(true);
  const [showReEnteredPin, setShowReEnteredPin] = useState(false);
  const buttonDisabled = newPin.length < 4 || reEnterPin.length < 4;
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const { setLoader } = useLoaderContext();

  const handleBackClick = () => {
    navigate("/auth/forgot");
  };

  const handleResetPin = () => {
    if (newPin !== reEnterPin) {
      setBackendErrorMsg("Entered PIN and Re-entered PIN dont match!");
    } else {
      const newPinData = {
        userId: localStorage.getItem("userId"),
        pin: newPin,
      };
      postNewPin(newPinData);
    }
  };

  const postNewPin = async (newPinData) => {
    setLoader(true);
    console.log(newPinData);
    try {
      const response = await resetPin(newPinData);
      console.log(response);
      if (response.status === 200) {
        setLoader(false);
        navigate("/auth/forgot/success");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      setBackendErrorMsg(error.message);
    }
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  return (
    <>
      <LoginBackButton onClick={handleBackClick} />
      <LoginLayout>
        <LoginInnerWrapperOther>
          <PowerGoAndSubheader />
          <WidthWrapper maxWidth="28rem">
            <ImgHeaderSubheader
              header={Text.resetYourPin}
              subheader={Text.setYourNewPin}
            />
          </WidthWrapper>
          <OTPFieldsWrapper>
            <OTPfield
              label={Text.enterNewPin}
              uniqueName="pinNewForgot"
              getEnteredOTP={setNewPin}
              hiddenNeeded
              showHideOTP={showNewPin}
              setShowHideOTP={() => setShowNewPin(!showNewPin)}
              autoFocus
            />
            <OTPfield
              label={Text.reEnterNewPin}
              uniqueName="pinReForgot"
              getEnteredOTP={setReEnterPin}
              hiddenNeeded
              showHideOTP={showReEnteredPin}
              setShowHideOTP={() => setShowReEnteredPin(!showReEnteredPin)}
            />
          </OTPFieldsWrapper>
          <WidthWrapper maxWidth="22.5rem">
            <Button
              label={Text.resetPin}
              onClick={handleResetPin}
              rightImgSrc={nextIcon}
              fontColor={Colors.white}
              fontSize="1.375rem"
              fontWeight="700"
              bgColor={Colors.brandTwo}
              topBottomPadding="0.75rem"
              labelImgGap="0.5rem"
              disabled={buttonDisabled}
            />
          </WidthWrapper>
        </LoginInnerWrapperOther>
      </LoginLayout>
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
    </>
  );
};

export default ForgotReset;
